const productData = [
  {
    id: 1,
    name: "Componibili Storage Unit",
    brand: "Kartell",
    category: "Storage",
    price: "115.00",
    reviews: "526",
    rating: "4.8",
    image: "/img/101.avif",
    images: ["/img/101.avif", "/img/101a.avif"],
    size: ["2-Tier", "3-Tier"],
    colors: ["White", "Black", "Red", "Silver"],
    material: "ABS plastic",
    description: [
      "Iconic modular storage designed to move easily from room to room and adapt to changing needs.",
      "Rounded sliding doors keep contents tucked away while maintaining a clean, modern silhouette.",
      "Works as a bedside table, entry catch-all, bathroom organizer, or compact media accessory.",
      "Lightweight yet sturdy construction makes it simple to reposition for everyday living.",
      "Stackable form factor creates a cohesive look when you add additional units over time.",
      "Easy-to-clean surface stands up to daily use in high-traffic spaces.",
    ],
    Features: [
      "Modular, stackable design",
      "Sliding tambour-style doors for quick access",
      "Compact footprint for small spaces",
      "Durable ABS construction",
      "Smooth edges for a refined finish",
      "Simple wipe-clean maintenance",
      "Multi-room versatility: bedroom, bath, office, and living spaces",
    ],
  },
  {
    id: 2,
    name: "Neutra Modern House Numbers",
    brand: "Modern House Numbers",
    category: "Outdoor Accessories",
    price: "140.00",
    reviews: "214",
    rating: "4.6",
    image: "/img/102.avif",
    images: ["/img/102.avif"],
    size: ['4"', '6"'],
    colors: ["Matte Black", "Brushed Stainless"],
    material: "Metal alloy with weather-resistant finish",
    description: [
      "Architectural address numbers inspired by midcentury modern signage and clean typography.",
      "Designed for curb appeal with crisp edges and balanced proportions that read clearly from the street.",
      "Weather-ready finish helps resist fading and corrosion in outdoor conditions.",
      "Pairs well with wood, brick, stucco, and contemporary exterior cladding.",
      "Ideal for front doors, gates, mailboxes, and entry columns.",
      "A simple upgrade that makes a home feel intentional and design-forward.",
    ],
    Features: [
      "Modern, legible numberform silhouette",
      "Outdoor-ready, weather-resistant finish",
      "Mounting hardware compatible with common surfaces",
      "Low-maintenance, wipe-clean surface",
      "Works for doors, mailboxes, gates, and entry columns",
      "Coordinates with contemporary exterior lighting and hardware",
      "Designed to read clearly from a distance",
    ],
  },
  {
    id: 3,
    name: 'Line Media Console, 70"',
    brand: "Herman Miller",
    category: "Storage",
    price: "2995.00",
    reviews: "146",
    rating: "4.7",
    image: "/img/103.avif",
    images: ["/img/103.avif"],
    size: ['70"'],
    colors: ["Walnut", "Oak", "Black"],
    material: "Wood veneer with powder-coated steel base",
    description: [
      "A streamlined media console that balances warm wood tones with crisp modern lines.",
      "Sized for 70-inch configurations to anchor living rooms without feeling bulky.",
      "Designed to manage everyday clutter: components, remotes, and accessories stay organized.",
      "Low, horizontal profile complements modern seating and keeps sightlines open.",
      "Versatile enough to function as a credenza in an office, bedroom, or dining space.",
      "A refined foundation for curated objects, books, and lighting.",
    ],
    Features: [
      "Generous storage volume for media components",
      "Clean, modern hardware and proportions",
      "Durable veneer surface for everyday use",
      "Sturdy metal base for stability",
      "Thoughtful layout to reduce visual clutter",
      "Works as media console or low credenza",
      "Minimal silhouette suited to modern interiors",
    ],
  },
  {
    id: 4,
    name: "Bacco Stool",
    brand: "Design Within Reach",
    category: "Seating",
    price: "395.00",
    reviews: "208",
    rating: "4.6",
    image: "/img/104.avif",
    images: ["/img/104.avif"],
    size: ["Counter Height", "Bar Height"],
    colors: ["Natural", "Black", "Warm Gray"],
    material: "Solid wood seat with powder-coated steel base",
    description: [
      "A refined stool with a compact footprint for kitchens, counters, and casual dining spaces.",
      "Balanced proportions and clean geometry complement modern interiors and open-plan layouts.",
      "Supportive seat profile encourages comfortable perching for meals or conversation.",
      "Durable finishes handle daily use in high-traffic spaces.",
      "Pairs easily with minimalist lighting and streamlined cabinetry.",
      "A versatile accent for home bars, islands, and studio spaces.",
    ],
    Features: [
      "Counter and bar height options",
      "Supportive footrest for comfort",
      "Sturdy steel frame for stability",
      "Smooth wood seat for a warm touch",
      "Easy-to-clean surfaces",
      "Modern silhouette suited to kitchens and bars",
      "Compact footprint for small spaces",
    ],
  },
  {
    id: 5,
    name: "Bacco Chair",
    brand: "Design Within Reach",
    category: "Seating",
    price: "895.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/105.avif",
    images: ["/img/105.avif"],
    size: ["Standard"],
    colors: ["Natural", "Black", "Saddle", "Ivory"],
    material: "Upholstered seat with solid wood frame",
    description: [
      "A modern chair that pairs clean lines with inviting comfort for everyday living.",
      "Supportive seat and back create a relaxed sit for dining, desk work, or conversation.",
      "Warm materials and restrained detailing fit seamlessly into modern and transitional rooms.",
      "Designed as an easy mix-and-match piece: works around a table or as a standalone accent.",
      "Proportions feel light in the room while remaining sturdy and grounded.",
      "A versatile option for open-plan spaces and flexible seating needs.",
    ],
    Features: [
      "Comfortable, supportive seat profile",
      "Solid wood structure for durability",
      "Upholstered surfaces designed for everyday use",
      "Works as dining chair, desk chair, or accent chair",
      "Clean, modern geometry",
      "Easy to style with a range of tables and rugs",
      "Designed for long-lasting comfort",
    ],
  },
  {
    id: 6,
    name: "Lína Swivel Chair",
    brand: "Woodard Furniture Company",
    category: "Outdoor",
    price: "2495.00",
    reviews: "98",
    rating: "4.7",
    image: "/img/106.avif",
    images: ["/img/106.avif"],
    size: ["Standard"],
    colors: ["White", "Black", "Sage", "Navy", "Terracotta"],
    material: "Powder-coated steel mesh",
    description: [
      "A sculptural swivel chair designed to bring modern comfort to patios, decks, and garden rooms.",
      "Open mesh construction keeps the silhouette light while providing supportive seating.",
      "Smooth swivel motion makes it easy to engage in conversation and enjoy the view.",
      "Weather-ready powder coating helps protect against the elements for outdoor living.",
      "Pairs beautifully with low outdoor tables and sectional arrangements.",
      "A modern classic look inspired by iconic midcentury outdoor design.",
    ],
    Features: [
      "Swivel base for effortless movement",
      "Powder-coated steel mesh for durability",
      "Lightweight, airy profile",
      "Outdoor-ready construction",
      "Available in a range of modern colors",
      "Coordinates with matching outdoor tables and seating",
      "Designed for patios, balconies, and covered porches",
    ],
  },
  {
    id: 7,
    name: "Emmy Sofa",
    brand: "Woodard Furniture Company",
    category: "Outdoor",
    price: "4495.00",
    reviews: "74",
    rating: "4.8",
    image: "/img/107.avif",
    images: ["/img/107.avif"],
    size: ['84"', '96"'],
    colors: ["White", "Black", "Sage", "Navy", "Terracotta"],
    material: "Powder-coated aluminum frame with performance upholstery",
    description: [
      "An outdoor sofa designed for relaxed lounging with a clean, modern silhouette.",
      "Deep, supportive cushions invite long conversations and laid-back afternoons outside.",
      "Performance materials stand up to everyday outdoor life while maintaining a refined look.",
      "Low profile and tailored lines complement contemporary architecture and landscape design.",
      "Pairs well with coordinating lounge chairs, coffee tables, and side tables.",
      "A statement piece that feels equally at home poolside or on a covered terrace.",
    ],
    Features: [
      "Durable outdoor frame with modern finish",
      "Comfort-forward cushions with supportive structure",
      "Performance upholstery designed for outdoor environments",
      "Multiple size options to fit your space",
      "Pairs with matching outdoor seating collections",
      "Designed for patios, terraces, and sunrooms",
      "Minimal silhouette with refined detailing",
    ],
  },
  {
    id: 8,
    name: "Contour Stool",
    brand: "HAY",
    category: "Seating",
    price: "295.00",
    reviews: "186",
    rating: "4.6",
    image: "/img/108.avif",
    images: ["/img/108.avif"],
    size: ["Low", "Counter"],
    colors: ["Black", "Olive", "Chalk", "Rust"],
    material: "Powder-coated steel",
    description: [
      "A modern stool with crisp lines and a sculpted profile that feels light in any space.",
      "Designed to tuck neatly under counters while still offering comfortable support.",
      "Powder-coated construction makes it durable for daily use in kitchens and studios.",
      "Works as extra seating, a perch at a vanity, or an accent in a living space.",
      "Minimal design pairs with both warm woods and cooler industrial finishes.",
      "An easy way to add flexible seating without visual bulk.",
    ],
    Features: [
      "Powder-coated steel for durability",
      "Clean silhouette suitable for modern interiors",
      "Low and counter height options",
      "Compact footprint for small spaces",
      "Easy wipe-clean maintenance",
      "Stable base for everyday use",
      "Versatile seating for kitchens and studios",
    ],
  },
  {
    id: 9,
    name: "HAY Colour Crate Wheels",
    brand: "HAY",
    category: "Storage Accessories",
    price: "25.00",
    reviews: "412",
    rating: "4.7",
    image: "/img/109.avif",
    images: ["/img/109.avif"],
    size: ["Set of 4"],
    colors: ["Black", "White"],
    material: "Powder-coated steel with durable rubber",
    description: [
      "A simple add-on that turns your storage crate into a mobile organizer.",
      "Smooth rolling action makes it easy to move supplies, toys, or linens from room to room.",
      "Designed to coordinate with modern storage systems and modular shelving.",
      "Ideal for home offices, studios, kids’ rooms, and closets that need flexibility.",
      "Durable materials support everyday use while keeping the look clean and minimal.",
      "An effortless upgrade that adds function without adding visual clutter.",
    ],
    Features: [
      "Set of 4 wheels for one crate",
      "Durable, smooth-rolling casters",
      "Designed to fit compatible crate bases",
      "Quick way to add mobility to storage",
      "Modern finish to match contemporary interiors",
      "Ideal for offices, closets, and kids’ spaces",
      "Built for everyday movement on common flooring",
    ],
  },
  {
    id: 10,
    name: "Knot Pillow",
    brand: "Design Within Reach",
    category: "Textiles",
    price: "165.00",
    reviews: "268",
    rating: "4.8",
    image: "/img/1010.avif",
    images: ["/img/1010.avif"],
    size: ["One Size"],
    colors: ["Natural", "Charcoal", "Blush", "Sage"],
    material: "Wool blend knit with soft fill",
    description: [
      "A sculptural accent pillow that brings softness and visual interest to any seating area.",
      "Knot-inspired form adds dimension to sofas, lounge chairs, and beds without feeling fussy.",
      "Textured knit surface feels cozy and inviting for everyday lounging.",
      "Pairs easily with solid throws, tonal palettes, or high-contrast modern rooms.",
      "A statement piece that still works as a functional cushion when you need extra comfort.",
      "Designed to look great from every angle on open-plan seating.",
    ],
    Features: [
      "Sculptural knot form for modern styling",
      "Soft knit exterior with comfortable fill",
      "Works as accent pillow on sofas, beds, and chairs",
      "Adds texture and dimension to layered textiles",
      "Easy to mix with solids and patterns",
      "Designed to hold its shape",
      "A modern décor update with a playful edge",
    ],
  },
  {
    id: 11,
    name: "Line Console",
    brand: "Herman Miller",
    category: "Storage",
    price: "1895.00",
    reviews: "112",
    rating: "4.7",
    image: "/img/1011.avif",
    images: ["/img/1011.avif"],
    size: ["Standard"],
    colors: ["Walnut", "Oak", "Black"],
    material: "Wood veneer with metal base",
    description: [
      "A refined console designed to bring practical storage and display space to modern rooms.",
      "Slim proportions make it ideal for entryways, behind sofas, or narrow walls.",
      "Wood veneer adds warmth while the clean silhouette keeps the look contemporary.",
      "Designed to support everyday routines: keys, mail, lighting, and small essentials.",
      "Pairs well with mirrors, statement art, and minimalist table lamps.",
      "A versatile anchor that helps a room feel finished and intentional.",
    ],
    Features: [
      "Space-saving silhouette for entryways and hallways",
      "Durable veneer surface for daily use",
      "Stable base for confident placement",
      "Modern proportions suitable for contemporary interiors",
      "Easy styling with décor and lighting",
      "Works behind sofas or along walls",
      "Clean lines and minimal hardware",
    ],
  },
  {
    id: 12,
    name: "Terassi Lounge Chair",
    brand: "Design Within Reach",
    category: "Outdoor",
    price: "1875.00",
    reviews: "83",
    rating: "4.7",
    image: "/img/1012.avif",
    images: ["/img/1012.avif"],
    size: ["Standard"],
    colors: ["Natural Teak", "Black", "Warm Gray"],
    material: "Outdoor-grade wood with weather-resistant upholstery",
    description: [
      "A lounge chair designed for outdoor living, from pool decks to covered patios.",
      "Relaxed recline and supportive cushions invite long sits in the sun or shade.",
      "Natural materials add warmth while the silhouette stays crisp and modern.",
      "Built with outdoor durability in mind for seasons of use.",
      "Pairs easily with side tables and outdoor sectionals for a cohesive setup.",
      "A versatile piece that feels elevated without being formal.",
    ],
    Features: [
      "Outdoor-ready frame and finish",
      "Supportive lounge posture for comfort",
      "Weather-appropriate materials",
      "Works poolside, patio, or sunroom",
      "Coordinates with outdoor tables and sofas",
      "Modern silhouette with warm material presence",
      "Designed for everyday outdoor relaxation",
    ],
  },
  {
    id: 13,
    name: "Salt Chair",
    brand: "Design Within Reach",
    category: "Seating",
    price: "395.00",
    reviews: "244",
    rating: "4.7",
    image: "/img/1013.avif",
    images: ["/img/1013.avif"],
    size: ["Standard"],
    colors: ["Natural", "Black", "Stone", "Sage"],
    material: "Molded shell with sturdy base",
    description: [
      "A versatile chair designed to work at the dining table, desk, or as extra seating.",
      "Comfortable seat profile supports everyday use without sacrificing clean modern lines.",
      "Light visual footprint makes it easy to use in sets without crowding a room.",
      "Pairs with both wood and metal tables for a balanced, contemporary look.",
      "Built for durability with materials chosen for long-term performance.",
      "A simple way to add design consistency across open-plan living spaces.",
    ],
    Features: [
      "Comfortable, supportive molded seat",
      "Durable base for everyday use",
      "Works as dining, desk, or accent chair",
      "Clean silhouette with modern proportions",
      "Easy to mix with a variety of tables",
      "Available in contemporary color options",
      "Designed for small and large dining setups",
    ],
  },
  {
    id: 14,
    name: "Cove Bed",
    brand: "Herman Miller",
    category: "Bedroom",
    price: "3495.00",
    reviews: "92",
    rating: "4.8",
    image: "/img/1014.avif",
    images: ["/img/1014.avif"],
    size: ["Queen", "King"],
    colors: ["Oat", "Charcoal", "Stone"],
    material: "Upholstered frame with solid wood structure",
    description: [
      "A modern bed designed to make the bedroom feel calm, cohesive, and elevated.",
      "Upholstered surfaces add softness while maintaining a clean, architectural profile.",
      "Balanced proportions work well in both spacious primary suites and compact bedrooms.",
      "A comfortable foundation for layered bedding, pillows, and modern lighting.",
      "Built with durability in mind to support years of daily use.",
      "Designed to pair easily with contemporary nightstands and storage pieces.",
    ],
    Features: [
      "Available in Queen and King sizes",
      "Upholstered frame for a soft, refined look",
      "Sturdy internal structure for long-term durability",
      "Designed to anchor modern bedroom layouts",
      "Pairs with contemporary nightstands and dressers",
      "Comfort-forward proportions",
      "Clean lines for a minimal aesthetic",
    ],
  },
  {
    id: 15,
    name: "Quilton Lift Sofa",
    brand: "HAY",
    category: "Seating",
    price: "5995.00",
    reviews: "68",
    rating: "4.8",
    image: "/img/1015.avif",
    images: ["/img/1015.avif"],
    size: ["2-Seater", "3-Seater"],
    colors: ["Ivory", "Charcoal", "Sage", "Camel"],
    material: "Upholstered sofa with high-resilience foam",
    description: [
      "A generously cushioned sofa designed for everyday lounging and modern living.",
      "Deep, structured comfort balances softness with a tailored silhouette.",
      "Modular-friendly proportions help it work in open-plan spaces and dedicated living rooms.",
      "A strong visual presence that still feels refined thanks to clean geometry.",
      "Pairs naturally with modern rugs, low tables, and sculptural lighting.",
      "Designed to be the anchor piece for relaxed, contemporary interiors.",
    ],
    Features: [
      "Plush comfort with supportive structure",
      "Available in multiple seating sizes",
      "Modern silhouette with refined detailing",
      "High-quality upholstery designed for daily use",
      "Great as a primary living room anchor",
      "Pairs with low modern coffee tables",
      "Designed for long lounging sessions",
    ],
  },
  {
    id: 16,
    name: "Line Six Drawer Dresser",
    brand: "Herman Miller",
    category: "Bedroom",
    price: "3295.00",
    reviews: "121",
    rating: "4.7",
    image: "/img/1016.avif",
    images: ["/img/1016.avif"],
    size: ["Six Drawer"],
    colors: ["Walnut", "Oak", "Black"],
    material: "Wood veneer with smooth-glide hardware",
    description: [
      "A modern dresser that brings calm organization to the bedroom with clean lines and warm materials.",
      "Six spacious drawers provide storage for everyday essentials while keeping surfaces uncluttered.",
      "Refined proportions make it a strong anchor piece without overwhelming the room.",
      "Designed to pair easily with modern beds, nightstands, and lighting.",
      "Durable finishes and hardware support daily use for years to come.",
      "A timeless storage piece that works across evolving styles and spaces.",
    ],
    Features: [
      "Six-drawer layout for organized storage",
      "Smooth-glide drawer operation",
      "Durable veneer surfaces for everyday use",
      "Modern proportions with clean detailing",
      "Pairs well with contemporary bedroom collections",
      "Designed to reduce visual clutter",
      "Sturdy construction for long-term durability",
    ],
  },
  {
    id: 17,
    name: "Contour Chair",
    brand: "HAY",
    category: "Seating",
    price: "895.00",
    reviews: "174",
    rating: "4.7",
    image: "/img/1017.avif",
    images: ["/img/1017.avif"],
    size: ["Standard"],
    colors: ["Black", "Ivory", "Sage", "Rust"],
    material: "Upholstered seat with durable frame",
    description: [
      "A modern chair designed with soft curves and a balanced profile for everyday comfort.",
      "Comfortable for dining, working, or lounging in small conversational areas.",
      "Refined upholstery adds warmth and texture while maintaining a clean silhouette.",
      "Works well in sets or as a single accent chair in a bedroom or living room.",
      "Designed to complement modern tables, rugs, and lighting with ease.",
      "A flexible piece that supports the way contemporary homes shift and adapt.",
    ],
    Features: [
      "Comfort-focused seat and back profile",
      "Durable frame for everyday use",
      "Refined upholstery for a modern look",
      "Works as dining chair or accent seating",
      "Easy to style with modern interiors",
      "Available in contemporary colorways",
      "Designed for long-lasting comfort",
    ],
  },
  {
    id: 18,
    name: "Lauki Credenza",
    brand: "Treku",
    category: "Storage",
    price: "3995.00",
    reviews: "88",
    rating: "4.7",
    image: "/img/1018.avif",
    images: ["/img/1018.avif"],
    size: ["Standard"],
    colors: ["Oak", "Walnut", "White"],
    material: "Wood veneer with modern hardware",
    description: [
      "A modern credenza designed to bring organized storage and a refined presence to living spaces.",
      "Clean doors and drawers conceal everyday items while keeping the room visually calm.",
      "Low, horizontal form works well under art, beside dining tables, or as a media-friendly surface.",
      "Warm wood tones and crisp detailing suit contemporary and midcentury-inspired interiors.",
      "A versatile foundation for styling with books, objects, and sculptural lighting.",
      "Designed to help spaces feel finished, intentional, and easy to live in.",
    ],
    Features: [
      "Generous concealed storage for living or dining rooms",
      "Clean-lined doors and drawers to reduce visual clutter",
      "Durable veneer surfaces for everyday use",
      "Versatile placement: media, dining, or entry spaces",
      "Modern proportions with refined detailing",
      "Pairs well with contemporary lighting and art",
      "Built for long-term home organization",
    ],
  },
  {
    id: 19,
    name: "Line Five Drawer Dresser",
    brand: "Herman Miller",
    category: "Bedroom",
    price: "2895.00",
    reviews: "104",
    rating: "4.7",
    image: "/img/1019.avif",
    images: ["/img/1019.avif"],
    size: ["Five Drawer"],
    colors: ["Walnut", "Oak", "Black"],
    material: "Wood veneer with smooth-glide hardware",
    description: [
      "A streamlined dresser designed to bring order to the bedroom with modern simplicity.",
      "Five drawers offer practical storage while keeping the room calm and uncluttered.",
      "Balanced height works well beside beds, under mirrors, or along open walls.",
      "Clean lines and warm materials complement a wide range of modern interiors.",
      "Durable finishes support daily routines and long-term use.",
      "An easy foundational piece for a cohesive bedroom layout.",
    ],
    Features: [
      "Five-drawer layout for organized storage",
      "Smooth-glide drawers for daily use",
      "Durable veneer surfaces and refined detailing",
      "Modern proportions suited to contemporary bedrooms",
      "Pairs well with modern beds and nightstands",
      "Designed to reduce clutter and improve flow",
      "Sturdy construction for lasting performance",
    ],
  },
  {
    id: 20,
    name: "Tray Side Table",
    brand: "Woodard Furniture Company",
    category: "Outdoor",
    price: "495.00",
    reviews: "152",
    rating: "4.7",
    image: "/img/1020.avif",
    images: ["/img/1020.avif"],
    size: ["Standard"],
    colors: ["White", "Black", "Sage", "Navy", "Terracotta"],
    material: "Powder-coated steel",
    description: [
      "A minimal side table designed for effortless outdoor living and flexible styling.",
      "Compact footprint fits beside lounge chairs, sofas, and poolside seating.",
      "Tray-like top is practical for drinks, books, and everyday essentials.",
      "Powder-coated construction is designed for outdoor environments and easy care.",
      "Clean geometry pairs well with modern outdoor collections and architectural spaces.",
      "A simple piece that makes outdoor setups feel complete and intentional.",
    ],
    Features: [
      "Outdoor-ready powder-coated steel",
      "Compact size for versatile placement",
      "Tray-style top for practical use",
      "Coordinates with modern outdoor seating",
      "Easy-to-clean surface",
      "Designed for patios, decks, and terraces",
      "Stable base for everyday outdoor use",
    ],
  },
];

export default productData;
